import duplicateEditorIcon from '../../assets/editorIcons/duplicateEditorIcon.svg';
import switchEditorIcon from '../../assets/editorIcons/switchEditorIcon.svg';
import deleteEditorIcon from '../../assets/editorIcons/deleteEditorIcon.svg';
import penEditorIcon from '../../assets/editorIcons/penEditorIcon.svg';
import rubberEditorIcon from '../../assets/editorIcons/rubberEditorIcon.svg';
import { useTranslation } from "react-i18next";
import { Button } from '@mui/material';
import './EditorFunctionality.css';

const EditorFunctionality = ({duplicateElement, handleFlip, handleErase, handlePen, deleteElement, handleOpenDrawer, handleOpenDialog}) => {
    const {t} = useTranslation();

    return (
        <div className="editor-functionality">
        <button 
          className="cancel_design_btn"
          onClick={handleOpenDialog}
        >
          Cancel
        </button>
        <div className='v-line-left_mob'></div>
        <div className='editor_func_btns'>
        <Button
        onClick={duplicateElement}>
          <img className="editor_icon" src={duplicateEditorIcon} alt="Duplicate" />
        </Button>
        <Button onClick={handleFlip}>
          <img className="editor_icon" src={switchEditorIcon} alt="Delete" />
        </Button>
        <Button
          onClick={handleErase}
        >
          <img className="editor_icon" src={rubberEditorIcon} alt="Eraser" />
        </Button>
        <Button
          onClick={handlePen}
        >
          <img className="editor_icon" src={penEditorIcon} alt="Pen" />
        </Button>
        <Button
          onClick={deleteElement}
        >
          <img className="editor_icon" src={deleteEditorIcon} alt="Delete" />
        </Button>
        </div>
        <div className='v-line-right_mob'></div>
        <button 
          className="publish_design_btn"
          onClick={handleOpenDrawer}
          >
          {t("publish")}
        </button>
      </div>
    )
}

export default EditorFunctionality;